<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="combinationKey"
      border
      auto-resize
      highlight-hover-row
      resizable
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{ highlight: true, reserve: true }"
      @cell-click="onCellClick"
      @checkbox-change="onCheckboxChange"
      @checkbox-all="onCheckboxChange"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.evgBulkOrderStatus === 'Y'
              ? 'success'
              : row.evgBulkOrderStatus === 'S'
              ? 'warning'
              : row.evgBulkOrderStatus === 'D'
              ? 'danger'
              : 'primary'
          "
        >
          {{ row.v_evgBulkOrderStatus }}
        </el-tag>
      </template>
      <template v-slot:expandContent="{ row }">
        <div style="width: 1657px" class="p-2">
          <SkuTable
            :evgBulkOrderCode="row.evgBulkOrderCode"
            :tableData="row.bulkOrderSkuList"
            :scmCode="row.scmCode"
          />
        </div>
      </template>
      <template v-slot:displayCustomer="{ row }">
        <div>{{ row.platformName }}</div>
        <div>{{ row.custName }}</div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
import { format } from '@/libs/util.number.js'
import SkuTable from '../sku-table'
export default {
  mixins: [TableAutoHeight, EditLoading],
  components: { SkuTable },
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      format: (n) => format(n),
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    onCheckboxChange({ records, reserves }) {
      this.$emit('checkboxChange', records.concat(reserves))
    },
    clearCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('checkboxChange', [])
    },
    onCellClick({ row, column }) {
      const { property } = column
      const filterColumns = ['checkbox', 'expand']
      if (filterColumns.includes(property)) return

      const $table = this.$refs.table
      $table.toggleCheckboxRow(row)
      const data = $table.getCheckboxRecords(true) || []
      const reserves = $table.getCheckboxReserveRecords(true) || []
      this.$emit('checkboxChange', data.concat(reserves))
    },
  },
}
</script>
